<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';

defineProps<{
  title?: string,
  hideTitle?: boolean,
  class?: HTMLAttributes['class'],
}>();
</script>

<template>
  <slot>
    <span :class="$props.class">
      <LoadingOutlined class="mr-2" />
      <span v-if="title">
        {{ title }}
      </span>
      <span v-else-if="!hideTitle">
        Loading...
      </span>
    </span>
  </slot>
</template>
